import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  base: "/",
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/profile/home"
    },
    {
      path: "/profile",
      name: "profile",
      component: () => import("./views/Profile.vue"),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: "home",
          name: "home",
          component: () => import("./views/profile/general")
        },
        {
          path: "user-register",
          name: "user-register",
          component: () => import("./views/profile/register")
        },
        {
          path: "settings",
          name: "settings",
          component: () => import("./views/profile/settings")
        },
        {
          path: "tariffs/:lsId",
          props: true,
          name: "tariffs",
          component: () => import("./views/profile/tariffs")
        },
        {
          path: "ls/:lsId",
          props: true,
          name: "ls",
          component: () => import("./views/profile/ls_detail"),
          children: [
            {
              path: "service/:type",
              props: route => ({
                type: String,
                ...route.params
              }),
              name: "service",
              component: () => import("./views/profile/serviceDetail"),
              children: [
                {
                  path: "plan",
                  name: "plan",
                  component: () => import("./views/profile/serviceDetailPlan")
                },
                {
                  path: "traffic",
                  name: "traffic",
                  component: () => import("./views/profile/serviceDetailTraffic")
                },
                {
                  path: "payments-history",
                  name: "payments-history",
                  component: () => import("./views/profile/serviceDetailPayments")
                },
                {
                  path: "requisites",
                  name: "requisites",
                  component: () => import("./views/profile/serviceDetailRequisites")
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/Login.vue")
    },
    {
      path: "*",
      name: "404",
      component: () => import("./views/404.vue")
    }
  ]
});